import * as React from "react";
const IconMagnifyingGlassDollar = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M60.7 59.3 43.8 42.4c8.5-9.2 8.3-23.6-.7-32.5C38.7 5.4 32.8 3 26.5 3S14.3 5.4 9.9 9.9C5.4 14.3 3 20.2 3 26.5s2.4 12.2 6.9 16.6c4.6 4.6 10.6 6.9 16.6 6.9 5.7 0 11.4-2.1 15.9-6.2l16.9 16.9c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4M11.3 41.8C7.2 37.7 5 32.3 5 26.5s2.2-11.2 6.3-15.2S20.8 5 26.5 5c5.8 0 11.2 2.2 15.2 6.3 8.4 8.4 8.4 22.1 0 30.4-8.3 8.4-22 8.4-30.4.1" />
    <path d="M24.8 19.9H32c.6 0 1-.4 1-1s-.4-1-1-1h-3.4v-2.3c0-.6-.4-1-1-1s-1 .4-1 1v2.3h-1.8c-2.7 0-4.9 2.2-4.9 4.8s2.2 4.8 4.9 4.8h3.3c1.6 0 2.9 1.3 2.9 2.8s-1.3 2.8-2.9 2.8H21c-.6 0-1 .4-1 1s.4 1 1 1h5.6v2.3c0 .6.4 1 1 1s1-.4 1-1v-2.3c2.5-.2 4.4-2.3 4.4-4.8 0-2.7-2.2-4.8-4.9-4.8h-3.3c-1.6 0-2.9-1.3-2.9-2.8s1.3-2.8 2.9-2.8" />
  </svg>
);
export default IconMagnifyingGlassDollar;
